import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

interface PersonalizationCardProps {
  title: string;
  description: string;
  hidden?: boolean;
  children: React.ReactNode;
}

export function PersonalizationCard({
  title,
  description,
  children,
  hidden = false,
}: PersonalizationCardProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  function handleToggleExpand() {
    setIsExpanded((value) => !value);
  }

  if (hidden) {
    return null;
  }

  return (
    <div className="overflow-hidden rounded-lg border border-gray-200">
      <div
        className="flex cursor-pointer items-center justify-between p-6"
        onClick={handleToggleExpand}
        aria-expanded={isExpanded}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') handleToggleExpand();
        }}
      >
        <div>
          <h2 className="text-xl font-medium">{title}</h2>
          <p className="mt-1 text-gray-600">{description}</p>
        </div>

        <div>
          {isExpanded ? (
            <ChevronUp className="h-5 w-5 text-gray-500" />
          ) : (
            <ChevronDown className="h-5 w-5 text-gray-500" />
          )}
        </div>
      </div>

      {isExpanded && <div className="px-6 pb-6">{children}</div>}
    </div>
  );
}
